<template>
    <div class="login container">
        <div class="card">
            <div class="card-content">
                <p>Signin</p>
                <form @submit.prevent="login">
                    <div class="field">
                        <label for="email">email</label>
                        <input type="email" name ="email" v-model = "email">
                    </div>
                     <div class="field">
                        <label for="password">Password</label>
                        <input type="password" name ="password" v-model = "password">
                    </div>
                    <p>{{feedback}}</p>
                     <div class="field">
                       <button class = "btn-blue">Login</button>
                    </div>
                    
                </form>

            </div>
        </div>

    </div>
</template>
<script>
import firebase from "firebase"
export default {
    name:"Login",
    data(){
        return{
            email:null,
            password:null,
            feedback:null
        }
    },
    methods:{
        login(){
            if(this.email && this.password){
                firebase.auth().signInWithEmailAndPassword(this.email, this.password)
                .then(cred => {
                    this.$router.push({name:"Index"})
                }).catch(err => {
                    this.feedback = err.message
                })
            }else{
                this.feedback = "fill in both fields"
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/Login.vue